import { ApiError } from './ApiError';
import { type ValidationProblemDetails, type ValidationErrorList } from '../../types/error.types';

export class ValidationError extends ApiError {

    public readonly errors: ValidationErrorList;

    constructor(problem: ValidationProblemDetails) {
        super(problem);

        this.name = "ValidationError";
        this.errors = problem.errors ?? {};
    }

    getFieldErrors(field: string): string[] {
        return this.errors[field]?.map(e => e.description) ?? [];
    }

    get firstError(): string | undefined {
        const first = Object.values(this.errors)[0]?.[0];
        return first?.description;
    }
}